const typeToYMDHM = function (type) {
    if (type === 'date') {
        return 'yyyy-MM-dd';
    } else if (type === 'time') {
        return 'hh:mm';
    } else if (type === 'year-month') {
        return 'yyyy-MM';
    } else {
        return 'yyyy-MM-dd hh:mm';
    }
};

const ymdhmToType = function (type) {
    if (type === 'yyyy-MM-dd') {
        return 'date';
    } else if (type === 'hh:mm') {
        return 'time';
    } else if (type === 'yyyy-MM') {
        return 'year-month';
    } else {
        return 'datetime';
    }
};

export {typeToYMDHM, ymdhmToType};